import { slab, wallX, goal, sign, checkpoint, edgeLights, acid, ice, boost, mover } from '../kit.js';

/**
 * CHAPTER 2, SECTOR 15: FOUNDRY. The floor is the puzzle. Chapter 1 is an
 * acid slalom on foot (one center puddle teaches the hop), chapter 2 a
 * boost-lane switchboard where lane changes happen on bare plate and acid
 * separates the lanes, chapter 3 a vat crossing on movers with icy landing
 * islands over an acid lake. Falls into the vat dissolve and return to the
 * chapter checkpoint.
 */
export default {
  id: 'foundry',
  name: 'FOUNDRY',
  blurb: 'The floor is honest here. That is the problem.',
  mode: { type: 'sprint', par: 70 },
  redline: { seconds: 42 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 8], yaw: 0 },
  killY: -30,
  env: {
    fog: 0x1a0e08,
    fogDensity: 0.0046,
    sky: { zenith: 0x0f0604, horizon: 0x2a130a, glow: 0x8a3a1a, aurora: 0xff8a3c },
    floorY: -300,
  },
  objects: [
    // ---- chapter 1: acid slalom. The center puddle is the hop lesson.
    slab(0, 0, -16, 16, 52, 'plate', 1.4),
    ...edgeLights(0, 0, -16, 16, 52, 'amber'),
    wallX(-8.35, 0, -16, 52, 3, 'plate', 1.4),
    wallX(8.35, 0, -16, 52, 3, 'plate', 1.4),
    acid(-4, 0, -8, 3, 3),
    acid(4, 0, -14, 3, 3),
    acid(0, 0, -22, 2.5, 2.5),
    acid(-4, 0, -30, 3, 3),
    acid(4, 0, -34, 3, 3),
    ice(0, 0, -40, 10, 6),
    sign(0, 3.2, 4, 0, ['FOUNDRY', 'THE FLOOR IS THE PUZZLE', 'HOP THE ACID']),
    slab(0, 0, -50, 16, 12, 'plate', 1.4),
    checkpoint(0, 0, -50),
    sign(6, 2.6, -52, 0, ['COURIER LOG 02', 'THE FLOOR IS HONEST HERE', 'THAT IS THE PROBLEM'], '#4fdb5c'),

    // ---- chapter 2: the switchboard. Three boost lanes south, acid
    // between them; the bare bands are the only sane lane changes. The
    // center lane dies at the blocker, and stays dead through leg two.
    slab(0, 0, -84, 18, 56, 'plate', 1.4),
    boost(-5, 0, -70, 4, 24, [0, 0, -1], 26, 32),
    boost(0, 0, -70, 4, 24, [0, 0, -1], 26, 32),
    boost(5, 0, -70, 4, 24, [0, 0, -1], 26, 32),
    acid(-2.5, 0, -70, 1, 24),
    acid(2.5, 0, -70, 1, 24),
    acid(0, 0, -78, 4, 6),
    boost(-5, 0, -97, 4, 22, [0, 0, -1], 26, 32),
    boost(5, 0, -97, 4, 22, [0, 0, -1], 26, 32),
    acid(0, 0, -97, 4, 22),
    acid(-2.5, 0, -97, 1, 22),
    acid(2.5, 0, -97, 1, 22),
    sign(0, 3.4, -59, 0, ['PICK A LANE', 'CHANGE ON BARE PLATE'], '#ff8a3c'),
    slab(0, 0, -116, 16, 8, 'plate', 1.4),
    ...edgeLights(0, 0, -116, 16, 8, 'amber'),
    checkpoint(0, 0, -116),

    // ---- chapter 3: the vat. Movers over an acid lake; the islands are
    // iced so every landing slides and every departure is committed.
    slab(0, -6, -146, 30, 52, 'plate', 1.5),
    acid(0, -6, -146, 28, 50),
    mover(0, -0.6, -126, [0, -0.6, -138], [6, 0.8, 6], 7),
    slab(0, -0.6, -144, 8, 6, 'panel', 1.0),
    ice(0, -0.6, -144, 7, 5),
    mover(0, -0.6, -150, [8, -0.6, -160], [6, 0.8, 6], 7, { phase: 3.5 }),
    slab(8, -0.6, -168, 14, 10, 'panel', 1.2),
    ...edgeLights(8, -0.6, -168, 14, 10, 'lime'),
    sign(0, 2.4, -119, 0, ['THE VAT', 'RIDE, LAND, SLIDE, COMMIT'], '#ff8a3c'),
    goal(8, -0.6, -170, 0),
  ],
};
